// extracted by mini-css-extract-plugin
module.exports = {"main-component":"could_main-component__1TOjN"};